export default defineNuxtPlugin(() => {
  console.log('test.client.ts');

  return {
    provide: {
      hello: () => 'Hello from test.client.ts',
    },
  };
});
